export default "__VITE_ASSET__98a566a4__"